import React, { createContext, useContext, useState, useCallback } from 'react';

const MessagesUIContext = createContext(null);

export const useMessagesUI = () => {
  const context = useContext(MessagesUIContext);
  if (!context) {
    throw new Error('useMessagesUI must be used within MessagesUIProvider');
  }
  return context;
};

export const MessagesUIProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [openOptions, setOpenOptions] = useState({});

  const openMessages = useCallback((options = {}) => {
    setOpenOptions(options);
    setIsOpen(true);
  }, []);

  const closeMessages = useCallback(() => {
    setIsOpen(false);
    setOpenOptions({});
  }, []);

  const value = {
    isOpen,
    openOptions,
    openMessages,
    closeMessages,
  };

  return (
    <MessagesUIContext.Provider value={value}>
      {children}
    </MessagesUIContext.Provider>
  );
};

export default MessagesUIContext;
